export default {
    title: 'ឥណទានផ្សព្វផ្សាយ',
    amount: 'ចំនួនទឹកប្រាក់',
    status: 'ស្ថានភាព',
    due_date: 'កាលបរិច្ឆេទ​ផុត​កំណត់',
    spent: 'បានចំណាយ',
    type: 'ប្រភេទ',
    exp_date_from: 'កាលបរិច្ឆេទផុតកំណត់ពី',
};
